'use strict';

import {
    BufferGeometry,
    Float32BufferAttribute,
    Group, Points,
    PointsMaterial,
    TextureLoader, Vector3, Color
} from 'three';

import { assignDeep, projectMode, threeJsVariables } from '../../../settings';
import { Weather } from './Weather';
import { degToRad } from 'three/src/math/MathUtils';
import { OrbitDayAndNight } from '../../liveAnimations/DayNight/OrbitDayAndNight';
import { CLOUDS } from '../../liveAnimations/litemode/sky/Sky';

const DEFAULT_PARAMS = {
    uHorizon: 4.2,
    scale: 2.7,
    dark: 0.0,
    light: 0.111,
    cover: 0.5,
    alpha: -1.983,
    tint: 0.831,
    speed: 0.002
};


export class Clouds {
    constructor (weatherData) {

        if (projectMode.LiteMode.isActive()){
            this.active = false;
        } else {

            this.active = false;
            this.weatherData = weatherData;
            this.background = null;
            this.params = assignDeep(DEFAULT_PARAMS,config.features.weather.settings.clouds);
            this.prepareBackgroundMaterials();
        }

        return this;
    }

    #getCloudsDensity() {
        const density = this.weatherData.clouds.all;
        let preset = null;
        
        if (density === 0){
            preset = 0;
        } else if (density > 0 && density <= 10) {
            preset = 10;
        } else if (density > 10 && density <= 20) {
            preset = 20;
        } else if (density > 20 && density <= 30) {
            preset = 30;
        } else if (density > 30 && density <= 40) {
            preset = 40;
        } else if (density > 40 && density <= 50) {
            preset = 50;
        } else if (density > 50 && density <= 60) {
            preset = 60;
        } else if (density > 60 && density <= 70) {
            preset = 70;
        } else if (density > 70 && density <= 80) {
            preset = 80;
        } else if (density > 80 && density <= 90) {
            preset = 90;
        } else  {
            preset = 100;
        }
        
        return CLOUDS[preset];
    }

    enable() {

        if (projectMode.LiteMode.isActive()) {
            projectMode.LiteMode.cloudsToggle('enable');
            this.active = true;
        } else {
            if (!this.background) {
                this.prepareBackgroundMaterials();
                
                if (!this.background) return;
            }
            this.active = true;
            
            const currentWeather = Weather.checkedCurrentWeather();
            let cloudsCover = this.params.cover;
            let cloudsAlpha = this.params.alpha;
            let cloudsSpeed = this.params.speed;
    
            if (currentWeather) {
                const preset = this.#getCloudsDensity();
                cloudsCover = preset.cover;
                cloudsAlpha = preset.alpha;
                cloudsSpeed = this.weatherData.wind.speed / 1000;
            }
            
            this.background.traverse(el => {
                if (el.isMesh) {
                    el.material.uniforms.cloudsCover.value = cloudsCover;
                    el.material.uniforms.cloudsAlpha.value = cloudsAlpha;
                    el.material.uniforms.uSpeed.value = cloudsSpeed;
                    el.material.uniforms.cloudsActive.value = 1.0;
                }
            });
        }

    }

    disable() {

        if (projectMode.LiteMode.isActive()) {
            projectMode.LiteMode.cloudsToggle('disable');
            this.active = false;
        } else {

            this.active = false;
            this.background && this.background.traverse(el => {
                if (el.isMesh) {
                    el.material.uniforms.cloudsActive.value = 0.0;
                }
            });
        }

    }

    update(time) {
        if (!projectMode.LiteMode.isActive()) {
            if (this.active && this.background) {
                this.background.traverse(el => {
                    if (el.isMesh) {
                        el.material.uniforms.uTime.value = time;
                    }
                })
                // this.particles.forEach(particle => particle.tick());
            }
        }
    }
    
    prepareBackgroundMaterials() {
       this.background = threeJsVariables.background;
        this.background && this.background.traverse(el => {
            if (el.isMesh) {
                el.material.uniforms.cloudsScale.value = this.params.scale;
                el.material.uniforms.cloudsDark.value = this.params.dark;
                el.material.uniforms.cloudsLight.value = this.params.light;
                el.material.uniforms.cloudsCover.value = this.params.cover;
                el.material.uniforms.cloudsAlpha.value = this.params.alpha;
                el.material.uniforms.cloudsTint.value = this.params.tint;
                el.material.uniforms.horizon.value = this.params.uHorizon;
                el.material.uniforms.uSpeed.value = this.params.speed;
            }
        });
    }
}
